import { isLoading, Loading } from "../loading";
import { useAllTaskTypes } from "./useTaskTypes";
import { Task } from "../types/Task";
import { redirect } from "../util";

export const useAfterCreate = (
  task: Record<string, unknown> | null | undefined | Loading
): ((createdTask: Task) => void) => {
  const { data: taskTypes, isLoading: isTaskTypesLoading } = useAllTaskTypes();

  if (
    isLoading(task) ||
    isTaskTypesLoading ||
    !taskTypes ||
    task === undefined
  ) {
    return () => {};
  }

  const executeAfterCreate = (createdTask: Task) => {
    const createdTaskType = taskTypes.find(
      (type) => type.id === createdTask.task_type_id
    );

    const afterCreate = createdTaskType?.after_create;

    if (!afterCreate) {
      return;
    }

    const { id, props } = afterCreate;

    switch (id) {
      case "redirect": {
        redirect(props.url, props.openNewTab);
        return;
      }
      default:
        return;
    }
  };

  return executeAfterCreate;
};
